import { render, staticRenderFns } from "./DialogIdeaInviteCollaborator.vue?vue&type=template&id=2c655534&scoped=true"
import script from "./DialogIdeaInviteCollaborator.vue?vue&type=script&lang=js"
export * from "./DialogIdeaInviteCollaborator.vue?vue&type=script&lang=js"
import style0 from "./DialogIdeaInviteCollaborator.vue?vue&type=style&index=0&id=2c655534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c655534",
  null
  
)

export default component.exports